import SidekickModuleSpec, {
  BTResource,
  ControlCategorySpec,
  ControlType,
  ExternalAction,
} from 'src/models/Sidekick/SidekickModuleSpec';

const getDefaultExternalActionControlCategories = (
  resultMemoryName: string,
  resultMemoryExplorer: string
): ControlCategorySpec[] => [
  {
    name: '',
    controlGroups: [
      {
        name: '',
        controls: [
          {
            name: 'resultMemoryName',
            type: ControlType.MEMORY_EXPLORER_NAME,
            prompt: 'Name the Memory collected from this Action. Learn about naming a Memory in our Help Docs.',
            defaultValue: resultMemoryName,
          },
          {
            name: 'resultMemoryExplorer',
            type: ControlType.MEMORY_EXPLORER,
            prompt: 'View Memory',
            defaultValue: resultMemoryExplorer,
          },
        ],
      },
    ],
  },
];

export const convertExternalActionToModuleSpec = (action: ExternalAction): SidekickModuleSpec => {
  return {
    id: `externalAction-${action.name}`,
    name: `externalAction - ${action.displayName}`,
    presentableName: action.displayName != '' ? action.displayName : action.name,
    presentableDescription: action.description ?? '',
    controlCategories: (action.results.length > 0
      ? getDefaultExternalActionControlCategories(action?.results[0]?.name || '', '')
      : []) as ControlCategorySpec[],
    externalAction: action,
    modifiers: [],
    previews: [],
    integrations: null,
    inMemories: null,
    outMemories: null,
  };
};

const extractSubdomainFromHelpdeskUrl = (helpdeskUrl: string): string | null => {
  if (!helpdeskUrl) return null;

  try {
    const url = new URL(helpdeskUrl);
    const hostname = url.hostname;

    // Split hostname by dots and get the first part (subdomain)
    const parts = hostname.split('.');
    if (parts.length >= 2) {
      return parts[0] || null;
    }
  } catch (error) {
    // Silently failed to parse helpdesk URL
  }

  return null;
};

export const convertBTreeResourceToModuleSpec = (btResource: BTResource): SidekickModuleSpec => {
  const subdomain = extractSubdomainFromHelpdeskUrl(btResource.helpdeskUrl);

  let id = `bt-resource-${btResource.metadata.name}`;
  if (subdomain) {
    id = `bt-resource-${subdomain}-${btResource.metadata.name}`;
  }

  let presentableName = btResource.metadata.name;
  if (subdomain) {
    presentableName = `${subdomain} - ${btResource.metadata.name}`;
  }

  return {
    id,
    name: btResource.id,
    presentableName,
    presentableDescription: btResource.metadata.description,
    modifiers: [],
    previews: [],
    integrations: null,
    inMemories: null,
    outMemories: null,
    externalAction: null,
    controlCategories: [],
    btResource,
  };
};
